import "./App.scss";
import { OpKind } from "@taquito/taquito";
import {DappCore, SyncButton} from "./components/DappCore";
import React, { useState } from "react";

const manager = new DappCore();

const replace = (arr, index, item) => {
	return [...arr.slice(0,index), item, ...arr.slice(index+1)];
};

interface ListSpecProps {
	arr: any;
	setArr: any;
	types: any;
}
  
export const ListSpec = ({ arr, setArr, types }: ListSpecProps) => {

	const placeholder = types.map(x => x.length===3 ? x[2]: "");
  
	const handleChange = (e: React.FormEvent<HTMLInputElement>, i: number, j: number): void => {
		setArr( replace(arr, i, replace(arr[i], j, e.currentTarget.value)) );
	};
  
	const handleAdd = (i: number) => {
	  	setArr( [...arr.slice(0,i+1), placeholder, ...arr.slice(i+1)] );
	};
  
	const handleRemove = (i: number) => {
		if (arr.length > 1) {
			setArr( [...arr.slice(0,i), ...arr.slice(i+1)] );
		}
	}
	
	return (
	  <div>
		{arr.map((x,i) => {
		  return <div key={i}>
			
			{types.map((y,ii) => {
			  return <div className="row" key={ii}>
				{(i===0) ? (
				  <>
				  <label style={{display:"block", width:"200px"}} htmlFor="form">{types[ii][1]}</label>
				  <input style={{width:"200px"}} id="form" type={types[ii][0]} onChange={e => handleChange(e,i,ii)} value={arr[i][ii]}></input>
				  </>
				) : (
				  <input style={{width:"200px"}} id="form" type={types[ii][0]} onChange={e => handleChange(e,i,ii)} value={arr[i][ii]}></input>
				)}
			  </div>
			})}
			
			{(i===0) ? (
			  <>
				<div className="row">
				  <label style={{display:"block"}} htmlFor="addbutton">Add</label>
				  <button style={{display:"block", width:"50px"}} id="addbutton" onClick={e => handleAdd(i)}>+</button>
				</div>
				<div className="row">
				  <label style={{display:"block"}} htmlFor="removebutton">Remove</label>
				  <button style={{display:"block", width:"50px"}} id="removebutton" onClick={e => handleRemove(i)}>-</button>
				</div>
			  </>
			) : (
			  <>
				<div className="row">
				  <button style={{width:"50px"}} onClick={e => handleAdd(i)}>+</button>
				</div>
				<div className="row">
				  <button style={{width:"50px"}} onClick={e => handleRemove(i)}>-</button>
				</div>
			  </>  
			)}
		  </div>
		})}
	  </div>
	);
};


interface ArgSpecProps {
	value: any;
	setValue: any;
	types: any;
}

export const ArgSpec = ({ value, setValue, types }: ArgSpecProps) => {

	const handleChange = (e: React.FormEvent<HTMLInputElement>, i: number): void => {
		setValue( value.map((v,j) => i === j ? e.currentTarget.value : value[j]) );
  	};

	return (
		<div>
			{types.map((x,i) => {
				return <div key={i} className="row">
					<label style={{display:"block", width:"200px"}} htmlFor="form">{x[1]}</label>
					<input style={{width:"200px"}} id="form" type={x[0]} onChange={e => handleChange(e,i)} value={value[i]}></input>			
				</div>
			})}
		</div>
	);

};



export const CallInner = (
	{ core, opFunc, afterCallback, contract, entrypoint, params } : 
	{
		core:any,
		opFunc?:any,
		afterCallback?:any,
		contract?:string,
		entrypoint?:string,
		params:any
	}) => {

	// make entrypoint pretty string

	const [inProgress, setInProgress] = useState<boolean>(false);
	if ((opFunc === undefined) && (entrypoint !== undefined)) {
		opFunc = async (core,param): Promise<any[]> => {
			const c = await core.Tezos.wallet.at(contract);
			let ops :any[] = [];
			ops.push({
				kind: OpKind.TRANSACTION,
				...c.methods[entrypoint](...param)
					.toTransferParams({ amount: 0, mutez: true, storageLimit: 500 })
			});
			return ops;
		};
	}
	const callContract = async (): Promise<void> => {
		setInProgress(true);
		try {
			if (core.beaconConnection) {
				let ops: any[] = await opFunc(core, params);
				let batch = await core.Tezos.wallet.batch(ops);
				const op = await batch.send();
				await op.confirmation();
				if (afterCallback !== undefined) {
					afterCallback();
				}
			}
		} catch (error) {
			console.log(error);
		} finally {
			setInProgress(false);
		}
	};
	return (
		<div>
			<button className="button" disabled={ inProgress } onClick={ callContract }>
				{ inProgress ? (
					<span>
					Please wait
					</span>
				) : (
					<span>
					{entrypoint}
					</span>
				)}
			</button>
	  	</div>
	);

};


export const BasicCallInterface = ({ core, opFunc, afterCallback, types, contract, entrypoint } : 
	{
		core:any,
		opFunc?:any,
		afterCallback?:any,
		types:any,
		contract?:string,
		entrypoint?:string
	}) => {

	const [value, setValue] = useState<any[]>(types.map(x => x.length===3 ? x[2]: ""));
	
	return (
		<div className="callPanel">
			<ArgSpec
				value={value}
				setValue={setValue}
				types={types}
			/>
			<CallInner
				core={core}
				opFunc={opFunc}
				afterCallback={afterCallback}
				contract={contract}
				entrypoint={entrypoint}
				params={value}
			/>
		</div>
	);
};


export const ListCallInterface = ({ core, opFunc, afterCallback, types, contract, entrypoint } : 
	{
		core:any,
		opFunc?:any,
		afterCallback?:any,
		types:any,
		contract?:string,
		entrypoint?:string
	}) => {

	const [arr, setArr] = useState<any>([types.map(x => x.length===3 ? x[2]: "")]);
	
	return (
		<div className="callPanel">
			<ListSpec
				arr={arr}
				setArr={setArr}
				types={types}
			/>
			<CallInner
				core={core}
				opFunc={opFunc}
				afterCallback={afterCallback}
				contract={contract}
				entrypoint={entrypoint}
				params={arr}
			/>
		</div>
	);
};


const make_contract_call = async (core,param): Promise<any[]> => {

	//const contract = "KT1DfymMp3qD5Pd5ujPjp7UsQbppY9yY1Hbf"; // fxhash ghostnet
	const contract = "KT1Xpmp15KfqoePNW9HczFmqaGNHwadV2a3b"; // fxhash mainnet
	const c = await core.Tezos.wallet.at(contract);

	let ops :any[] = [];
	ops.push({
		kind: OpKind.TRANSACTION,
		...c.methods.mint(null, "", 27396, null, null, null).toTransferParams({ amount: 5000000, mutez: true, storageLimit: 6500 })
	});

	return ops;
};


const App = () => {

	const [synced, setSynced] = useState<boolean>(false);

	return (
		<div className="box">

			<div className="container">

				<div className="callPanel">
					<SyncButton
						core={manager}
						synced={synced}
						setSynced={setSynced}
					/>
				</div>

				{
					synced
					?
					<BasicCallInterface
						core={manager}
						opFunc={make_contract_call}
						types={[]}
						entrypoint={"Mint"}
					/>
					:
					<div />
				}

				<div className="writing">
					Unfortunately, the storage limit required to mint Blockchain Automaton exceeds the limit on the fxhash frontend. You can mint on this site using the button above or on <a href="https://better-call.dev/mainnet/KT1Xpmp15KfqoePNW9HczFmqaGNHwadV2a3b/interact/mint">Better Call Dev</a> (issuer_id=27396).
				</div>

			</div>

		</div>
	)

};

export default App;
